import React, { Component, Fragment } from 'react';
import './App.css';
import {
    BrowserRouter as Router,
    Route,
  } from 'react-router-dom'
  import { Switch } from 'react-router';
import Dashboard  from './screens/dashboard';
import Auth  from './screens/auth';
import PrivateRoute from './components/PrivateRoute';

class App extends Component {
    render() {
        return (
            <Router>
                <Fragment>
                    <Switch>
                        <Route path="/auth" component={Auth} />
                        <PrivateRoute path="/" component={Dashboard} />
                    </Switch>
                </Fragment>
            </Router>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js